var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInternet = function SvgInternet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.5,
    d: "M11.538 8.322a.493.493 0 0 1 .924 0l.712 1.922c.1.27.312.483.582.582l1.922.712a.493.493 0 0 1 0 .924l-1.922.712a.99.99 0 0 0-.582.582l-.712 1.922a.493.493 0 0 1-.924 0l-.712-1.922a.99.99 0 0 0-.582-.582l-1.922-.712a.493.493 0 0 1 0-.924l1.922-.712c.27-.1.483-.312.582-.582z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.5,
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8 8c.673-3.532 2.21-6 4-6s3.327 2.468 4 6M8 16c.673 3.532 2.21 6 4 6s3.327-2.468 4-6M2 12h2.5M22 12h-2.5"
  })));
};
export default SvgInternet;